import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import withRouter from "components/Common/withRouter"

//i18n
import { withTranslation } from "react-i18next"
import SidebarContent from "./SidebarContent"

import { Link } from "react-router-dom"

import white_text_logo from "../../assets/images/logo/white_text_logo.png"
import white_mini_logo from "../../assets/images/logo/white_mini_logo.png"
import black_text_logo from "../../assets/images/logo/black_text_logo.png"
import black_mini_logo from "../../assets/images/logo/black_mini_logo.png"

const Sidebar = props => {
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={black_mini_logo} alt="" height="35" />
            </span>
            <span className="logo-lg">
              <img src={black_text_logo} alt="" height="50" />
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={white_mini_logo} alt="" height="35" />
            </span>
            <span className="logo-lg">
              <img src={white_text_logo} alt="" height="50" />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          <SidebarContent />
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  )
}
Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)))
